/**
 * Helper functions to create context objects for the AI Command Palette
 */

/**
 * Create a context object for a task page
 * @param {Object} task - The task object
 * @returns {Object} - The context object
 */
export const createTaskContext = (task) => {
  if (!task || !task.key) return null;

  return {
    type: 'task',
    label: task.key,
    data: {
      key: task.key,
      org: task.organization.slug,
    }
  };
};

/**
 * Create a context object for an organization page
 * @param {Object} organization - The organization object
 * @returns {Object} - The context object
 */
export const createOrganizationContext = (organization) => {
  if (!organization || !organization.slug) return null;
  
  return {
    type: 'organization',
    label: organization.name,
    data: {
      org: organization.slug
    }
  };
};

/**
 * Create a context object for a project page
 * @param {Object} project - The project object
 * @returns {Object} - The context object
 */
export const createProjectContext = (project) => {
  if (!project || !project.id) return null;
  
  return {
    type: 'project',
    label: project.name,
    data: {
      key: project.key,
      org: project.organizationSlug,
    }
  };
};

/**
 * Create a context object for a monitor page
 * @param {Object} monitor - The monitor object
 * @returns {Object} - The context object
 */
export const createMonitorContext = (monitor) => {
  if (!monitor || !monitor.id) return null;
  
  return {
    type: 'monitor',
    label: monitor.name,
    data: {
      id: monitor.id,
      name: monitor.name,
      url: monitor.url?.formatted,
      status: monitor.lastRun?.success ? 'up' : 'down',
      isActive: monitor.isActive,
      actionType: monitor.actionType,
      responseTime: monitor.lastRun?.result?.responseTime,
      uptime: monitor.stats?.last24h?.uptime
    }
  };
};

/**
 * Create a custom context object
 * @param {string} type - The context type
 * @param {string} label - The display label for the context
 * @param {Object} data - Additional data to include
 * @returns {Object} - The context object
 */
export const createCustomContext = (type, label, data = {}) => {
  if (!type || !label) return null;
  
  return {
    type,
    label,
    data
  };
}; 